import CriticalProfilesView from "./critical-profiles-view.jsx";

export default CriticalProfilesView;